// attachmentSerialization.js — separa o TEXTO do usuário dos ANEXOS serializados.
//
// O composer anexa os arquivos ao texto do turno (pro LLM "ver"), de duas formas:
//   • lista  "Anexos (N):" + linhas "- nome (X KB, type)"   (serializeAttachmentsToPrompt)
//   • blocos <file name="…" … />  ou  <file …>conteúdo</file> (serializeAttachmentsWithContent)
// Ótimo pro agente, FEIO na tela (o "código embaixo" que o Pedro reclamou). Aqui
// extraímos: { text: só o que o humano escreveu, files: [{name,sizeLabel,type}] }
// pra renderizar uma pill do design system em vez do XML cru. PURO — sem I/O.

const FILE_RE = /<file\s+name="([^"]*)"(?:\s+size="([^"]*)")?(?:\s+type="([^"]*)")?[^>]*?(?:\/>|>[\s\S]*?<\/file>)/gi;
const ANEXOS_RE = /\n*[ \t]*Anexos \(\d+\):[ \t]*(?:\n[ \t]*-[^\n]*)+/gi;

// Forma rica: blocos <file …> — fonte primária (dedupe por nome).
function parseFileBlocks(str) {
  const files = [];
  const seen = new Set();
  FILE_RE.lastIndex = 0;
  let m;
  while ((m = FILE_RE.exec(str)) !== null) {
    const name = m[1];
    if (name && !seen.has(name)) {
      seen.add(name);
      files.push({ name, sizeLabel: (m[2] || '').trim(), type: (m[3] || '').trim() });
    }
  }
  return files;
}

// Uma linha da lista "Anexos (N):" → { name, sizeLabel, type } (ou null).
function parseAnexoLine(raw) {
  const line = raw.trim();
  if (!line.startsWith('-')) return null;
  const item = line.replace(/^-\s*/, '');
  if (!item) return null;
  const mm = item.match(/^(.+?)\s*\(([^)]*)\)\s*$/); // "nome (12 KB, image/png)"
  if (!mm) return { name: item, sizeLabel: '', type: '' };
  const meta = mm[2].split(',').map((x) => x.trim());
  return { name: mm[1].trim(), sizeLabel: meta[0] || '', type: meta[1] || '' };
}

// Fallback: lista "Anexos (N):" (quando não há blocos <file>).
function parseAnexosList(str) {
  const list = str.match(/\bAnexos \(\d+\):[ \t]*((?:\n[ \t]*-[^\n]*)+)/i);
  if (!list) return [];
  return list[1].split('\n').map(parseAnexoLine).filter(Boolean);
}

/**
 * @param {string} text conteúdo bruto da mensagem do usuário
 * @returns {{ text: string, files: Array<{ name: string, sizeLabel: string, type: string }> }}
 */
export function extractAttachments(text) {
  const str = String(text ?? '');
  const files = parseFileBlocks(str);
  if (files.length === 0) files.push(...parseAnexosList(str));
  const cleaned = str
    .replace(FILE_RE, '')
    .replace(ANEXOS_RE, '')
    .replace(/[ \t]+$/gm, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
  return { text: cleaned, files };
}
